import { createContext, useContext } from 'react';

import { Currency, MdAnyXModuleEnum, MdUserRole } from '@anyx/common-graphql';
import { AnyXLanguage, CurrencyUtils, TimezoneUtils } from '@anyx/shared-utils';

// AnyX Domain Type
export type Self = {
  id: string;
  lastName: string;
  firstName: string;
  name?: string;
  picture?: string;
  role: MdUserRole;
  email: string;
  currency: Currency;
  language: AnyXLanguage;
  timezoneId: string;
  availableModules: MdAnyXModuleEnum[];
  canManageUsers: boolean;
  accessAllStores: boolean;
  accountIds: string[];
  accounts: { id: string; name: string }[];
  storeIds: string[];
};

export type SelfContextType = {
  self: Self;
  refetch: () => void;
  isSet: boolean;
};

export const defaultSelf: SelfContextType = {
  self: {
    id: '',
    lastName: '',
    firstName: '',
    name: '',
    role: MdUserRole.MERCHANT,
    email: '',
    currency: CurrencyUtils.DEFAULT,
    language: AnyXLanguage.EN_US,
    timezoneId: TimezoneUtils.getLocalTimezone(),
    availableModules: [],
    canManageUsers: false,
    accessAllStores: false,
    accountIds: [],
    accounts: [],
    storeIds: [],
  },
  refetch: () => null,
  isSet: false,
};

export const SelfContext = createContext<SelfContextType>(defaultSelf);

export const useSelfCtx = () => {
  const { self, refetch, isSet } = useContext(SelfContext);
  return {
    self,
    refetch,
    isSet,
  };
};

export const useUserLanguage = () => {
  const {
    self: { language },
  } = useSelfCtx();
  return language;
};

export const useUserCurrency = () => {
  const {
    self: { currency },
  } = useSelfCtx();

  return CurrencyUtils.asCurrency(currency);
};
